(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5750],{

/***/ 86564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductsPins; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Slices/ImageWithLabel/index.tsx
var ImageWithLabel = __webpack_require__(53299);
// EXTERNAL MODULE: ./src/components/UI/Image/index.tsx
var Image = __webpack_require__(51025);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.tsx + 17 modules
var Icons = __webpack_require__(54678);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Link/index.js
var Link = __webpack_require__(13200);
// EXTERNAL MODULE: ./src/components/UI/ProductCard/types.ts
var types = __webpack_require__(72206);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/ProductPinTag/styles.module.scss
var styles_module = __webpack_require__(166);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductPinTag/index.tsx












var cx = bind_default().bind((styles_module_default()));
function ProductPinTag(param) {
    var className = param.className, designer = param.designer, name = param.name, link = param.link, price = param.price, image = param.image;
    var tagStyle = (0,StyleProvider/* useStyle */.X)({
        backgroundColor: colors/* GlobalThemeColors.White */.b.White
    });
    var designerStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12SangBleu */.C.Label12SangBleu,
        textStyling: text_styling/* GlobalTextStyling.Capitalize */.l.Capitalize
    });
    var priceStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk
    });
    var nameStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var hasContent = designer || price || name;
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                className: cx((styles_module_default()).image),
                layout: "fill",
                objectFit: "cover",
                sizesFromBreakpoints: [
                    {
                        ratio: 3 / 10
                    }
                ],
                loader: image.loaderType === types/* CARD_IMAGE_LOADER.STORYBLOK */.p.STORYBLOK ? Image/* imageLoaderStoryblok */.y : null
            }, image.data)),
            hasContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx((styles_module_default()).content),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cx((styles_module_default()).topLine),
                        children: [
                            designer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: cx((styles_module_default()).designer, designerStyle),
                                children: designer
                            }),
                            price && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: cx((styles_module_default()).price, priceStyle),
                                children: price
                            })
                        ]
                    }),
                    name && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx((styles_module_default()).name, nameStyle),
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx((styles_module_default()).mockButton),
                        children: "[+]"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx((styles_module_default()).ProductPinTag, className, tagStyle),
        children: link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: cx((styles_module_default()).link)
        }, link), {
            children: content
        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: cx((styles_module_default()).container),
            children: content
        })
    });
}
ProductPinTag.defaultProps = {};
/* harmony default export */ var UI_ProductPinTag = (ProductPinTag);

// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/UI/PinMarker/styles.module.scss
var PinMarker_styles_module = __webpack_require__(93478);
var PinMarker_styles_module_default = /*#__PURE__*/__webpack_require__.n(PinMarker_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/PinMarker/index.tsx









var PinMarker_cx = bind_default().bind((PinMarker_styles_module_default()));
function PinToggle(param) {
    var className = param.className, position = param.position, onClick = param.onClick, theme = param.theme;
    var t = (0,lib/* useTranslate */.qM)();
    var toggleStyle = (0,StyleProvider/* useStyle */.X)({
        borderColor: theme
    });
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: PinMarker_cx((PinMarker_styles_module_default()).Toggle, className, toggleStyle),
        style: {
            left: "".concat(position.x, "%"),
            top: "".concat(position.y, "%")
        },
        onClick: onClick,
        "aria-label": (ref = t(dictionary/* CTA.CLOSE */.MV.CLOSE)) !== null && ref !== void 0 ? ref : "close",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CloseIcon */.Tw, {
            className: PinMarker_cx((PinMarker_styles_module_default()).icon),
            theme: theme
        })
    });
}
function PinMarker(param) {
    var index = param.index, product = param.product, position = param.position, activePin = param.activePin, theme = param.theme, onClick = param.onClick;
    var isActive = activePin === index;
    var horizontalHalf = Math.ceil((position === null || position === void 0 ? void 0 : position.x) / (100 / 2));
    var verticalThird = Math.ceil((position === null || position === void 0 ? void 0 : position.y) / (100 / 3));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PinToggle, {
                theme: theme,
                className: PinMarker_cx((PinMarker_styles_module_default()).toggle, {
                    isActive: isActive
                }),
                position: position,
                onClick: onClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: PinMarker_cx((PinMarker_styles_module_default()).tagContainer, (PinMarker_styles_module_default()).hideOnSmallScreen),
                style: {
                    left: "".concat(position.x, "%"),
                    top: "".concat(position.y, "%")
                },
                children: product && /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_ProductPinTag, (0,_object_spread/* default */.Z)({
                    className: PinMarker_cx((PinMarker_styles_module_default()).tag, (PinMarker_styles_module_default()) === null || (PinMarker_styles_module_default()) === void 0 ? void 0 : (PinMarker_styles_module_default())["HorizontalHalf-".concat(horizontalHalf)], (PinMarker_styles_module_default()) === null || (PinMarker_styles_module_default()) === void 0 ? void 0 : (PinMarker_styles_module_default())["VerticalThird-".concat(verticalThird)], {
                        hidden: !isActive
                    })
                }, product))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: PinMarker_cx((PinMarker_styles_module_default()).tagContainer, (PinMarker_styles_module_default()).hideOnLargeScreen),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_ProductPinTag, (0,_object_spread/* default */.Z)({
                    className: PinMarker_cx((PinMarker_styles_module_default()).tag, {
                        hidden: !isActive
                    })
                }, product))
            })
        ]
    });
}
PinMarker.defaultProps = {};
/* harmony default export */ var UI_PinMarker = (PinMarker);

// EXTERNAL MODULE: ./src/utils/number-as-boolean.ts
var number_as_boolean = __webpack_require__(98107);
// EXTERNAL MODULE: ./src/components/Abstracts/ProductsPins/styles.module.scss
var ProductsPins_styles_module = __webpack_require__(39041);
var ProductsPins_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductsPins_styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/ProductsPins/index.tsx










var ProductsPins_cx = bind_default().bind((ProductsPins_styles_module_default()));
function ProductPins(param) {
    var className = param.className, pins = param.pins, background = param.background, withActiveLayout = param.withActiveLayout, priority = param.priority, theme = param.theme, layout = param.layout;
    var ref = (0,react.useState)(null), activePin = ref[0], setActivePin = ref[1];
    var ref1 = (0,react.useState)(false), loadedBackground = ref1[0], setLoadedBackground = ref1[1];
    var containerStyle = {
        position: "relative",
        width: "100%"
    };
    var ref2;
    var pinsElement = (ref2 = pins === null || pins === void 0 ? void 0 : pins.map(function(pin, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_PinMarker, (0,_object_spread/* default */.Z)({
            theme: theme
        }, pin), "marker_".concat(index));
    })) !== null && ref2 !== void 0 ? ref2 : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProductsPins_cx(className, (ProductsPins_styles_module_default()).ProductsPins),
        style: containerStyle,
        children: [
            background && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                onClick: function() {
                    setActivePin(null);
                },
                onLoadingComplete: function() {
                    return setLoadedBackground(true);
                },
                priority: priority
            }, background), {
                layout: layout ? layout === ImageWithLabel/* IMAGE_SIZE.LARGE */.WQ.LARGE ? "responsive" : "fill" : "responsive"
            }), layout && {
                ratio: layout === ImageWithLabel/* IMAGE_SIZE.SMALL */.WQ.SMALL ? (ProductsPins_styles_module_default()).ratio : null
            }), {
                sizesFromBreakpoints: layout ? ImageWithLabel/* IMAGE_SIZES */.eM === null || ImageWithLabel/* IMAGE_SIZES */.eM === void 0 ? void 0 : ImageWithLabel/* IMAGE_SIZES */.eM[layout] : [
                    {
                        ratio: 1
                    }
                ]
            }), layout === ImageWithLabel/* IMAGE_SIZE.LARGE */.WQ.LARGE ? {} : {
                objectFit: "cover"
            })),
            withActiveLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    setActivePin(null);
                },
                style: {
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    left: 0,
                    top: 0,
                    backgroundColor: "#000000",
                    transition: "opacity 0.15s ease-in",
                    opacity: (0,number_as_boolean/* default */.Z)(activePin) ? 0.2 : 0
                }
            }),
            Array.isArray(pins) && loadedBackground && (pinsElement === null || pinsElement === void 0 ? void 0 : pinsElement.map(function(child, index) {
                var ref;
                /*#__PURE__*/ return react.cloneElement(child, {
                    className: child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : ref.className,
                    key: "item_".concat(index),
                    onClick: function() {
                        var ref, ref1;
                        child === null || child === void 0 ? void 0 : (ref = child.props) === null || ref === void 0 ? void 0 : (ref1 = ref.onClick) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
                        setActivePin(activePin === index ? null : index);
                    },
                    activePin: activePin,
                    index: index
                });
            }))
        ]
    });
}
ProductPins.defaultProps = {};
/* harmony default export */ var ProductsPins = (ProductPins);


/***/ }),

/***/ 49013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18357);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38250);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);









var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
function VideoComponent(_param, ref) {
    var className = _param.className, loading = _param.loading, src = _param.src, rootMargin = _param.rootMargin, style = _param.style, sources = _param.sources, poster = _param.poster, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "loading",
        "src",
        "rootMargin",
        "style",
        "sources",
        "poster"
    ]);
    var shouldLazyLoad = loading === "lazy";
    var _$ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_6__/* .useInView */ .YD)({
        skip: !shouldLazyLoad,
        triggerOnce: true,
        rootMargin: rootMargin
    }), 2), inViewRef = _$ref[0], inView = _$ref[1];
    var setRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(node) {
        ref && (ref.current = node);
        inViewRef(node);
    }, [
        ref,
        inViewRef
    ]);
    var shouldHaveSrc = !shouldLazyLoad || shouldLazyLoad && inView;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        className: cx(className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Video)),
        ref: setRef,
        src: shouldHaveSrc ? src : "",
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, style), {
            visibility: shouldHaveSrc ? "visible" : "hidden"
        }),
        poster: poster
    }, rest), {
        children: shouldHaveSrc && sources && sources.length > 0 && sources.map(function(source, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, source), "source".concat(index));
        })
    }));
}
var VideoComponentForwarded = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(VideoComponent);
VideoComponentForwarded.defaultProps = {
    loading: "eager",
    rootMargin: "200px 0px"
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoComponentForwarded);


/***/ }),

/***/ 68971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PageViewAnalytics; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13711);



function PageViewAnalytics(param) {
    var template = param.template;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = "".concat(router === null || router === void 0 ? void 0 : router.locale).concat(router === null || router === void 0 ? void 0 : router.pathname);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__/* .PageViewAnalytics */ .WA, {
        template: template,
        pathname: pathname
    });
}


/***/ }),

/***/ 53299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WQ": function() { return /* binding */ IMAGE_SIZE; },
/* harmony export */   "eM": function() { return /* binding */ IMAGE_SIZES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37444);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95348);
/* harmony import */ var _components_UI_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51025);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60118);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72487);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);










var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default()));
var IMAGE_SIZE = {
    LARGE: "large",
    SMALL: "small"
};
var _obj;
var IMAGE_SIZES = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, IMAGE_SIZE.LARGE, [
    {
        breakpoint: "md",
        ratio: 2 / 3
    },
    {
        ratio: 1
    }
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, IMAGE_SIZE.SMALL, [
    {
        breakpoint: "md",
        ratio: 1 / 3
    },
    {
        ratio: 1
    }
]), _obj);
function ImageWithLabel(param) {
    var className = param.className, image = param.image, label = param.label, layout = param.layout, aboveTheFold = param.aboveTheFold;
    var labelStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_5__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalTextPreset.Label12SangBleu */ .C.Label12SangBleu,
        color: _types_colors__WEBPACK_IMPORTED_MODULE_2__/* .GlobalThemeColors.Black */ .b.Black
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ImageWithLabel), className),
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image)),
                layout: layout === IMAGE_SIZE.LARGE ? "responsive" : "fill",
                ratio: layout === IMAGE_SIZE.SMALL ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ratio) : null,
                sizesFromBreakpoints: IMAGE_SIZES === null || IMAGE_SIZES === void 0 ? void 0 : IMAGE_SIZES[layout]
            }, layout === IMAGE_SIZE.LARGE ? {} : {
                objectFit: "cover"
            }, image), {
                priority: aboveTheFold
            })),
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label), labelStyle),
                children: label
            })
        ]
    });
}
ImageWithLabel.defaultProps = {};
/* harmony default export */ __webpack_exports__["ZP"] = (ImageWithLabel);


/***/ }),

/***/ 70544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Slices_PushGeneric; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useIsHover/index.js
var useIsHover = __webpack_require__(61356);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useDeviceType/index.js
var useDeviceType = __webpack_require__(9011);
// EXTERNAL MODULE: ./src/components/Abstracts/RichText/index.tsx + 2 modules
var RichText = __webpack_require__(7191);
// EXTERNAL MODULE: ./src/components/Abstracts/Video/index.tsx
var Video = __webpack_require__(49013);
// EXTERNAL MODULE: ./src/components/Abstracts/WrapperWithLink/index.tsx
var WrapperWithLink = __webpack_require__(95886);
// EXTERNAL MODULE: ./src/components/UI/Image/index.tsx
var Image = __webpack_require__(51025);
// EXTERNAL MODULE: ./src/components/UI/ImageHover/index.tsx
var ImageHover = __webpack_require__(97839);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/GenericCard/styles.module.scss
var styles_module = __webpack_require__(76156);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/GenericCard/index.tsx

















var cx = bind_default().bind((styles_module_default()));
var CardGenericLayoutType = {
    BIG: "big",
    REGULAR: "regular"
};
var _obj;
var IMAGE_SIZES = (_obj = {}, (0,_define_property/* default */.Z)(_obj, CardGenericLayoutType.BIG, [
    {
        breakpoint: "md",
        ratio: 930 / 1440
    },
    {
        ratio: 375 / 415
    }, 
]), (0,_define_property/* default */.Z)(_obj, CardGenericLayoutType.REGULAR, [
    {
        breakpoint: "md",
        ratio: 460 / 1440
    },
    {
        ratio: 375 / 415
    }, 
]), _obj);
function GenericCard(param) {
    var className = param.className, name = param.name, link = param.link, image = param.image, imageHover = param.imageHover, layout = param.layout, priority = param.priority, theme = param.theme, videoSrc = param.videoSrc;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useIsHover/* useIsHover */.c)(), 2), isHovered = ref[0], callbacks = ref[1];
    var device = (0,useDeviceType/* useDeviceType */.h)();
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: layout === CardGenericLayoutType.BIG ? text_preset/* GlobalTextPreset.Title20_24SangBleuRegular */.C.Title20_24SangBleuRegular : text_preset/* GlobalTextPreset.Title20_18SangBleu */.C.Title20_18SangBleu
    });
    var isHovering = device === useDeviceType/* DeviceType.mobile */.Y.mobile ? false : isHovered;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperWithLink/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link, callbacks), {
        className: cx((styles_module_default()).GenericCard, className, (styles_module_default()) === null || (styles_module_default()) === void 0 ? void 0 : (styles_module_default())["layout-".concat(layout)]),
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, image), {
                sizesFromBreakpoints: IMAGE_SIZES[layout],
                layout: "fill",
                objectFit: "cover",
                className: (styles_module_default()).image,
                asPlaceholder: true,
                priority: priority
            })),
            videoSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* default */.Z, {
                src: videoSrc,
                className: (styles_module_default()).video,
                poster: image === null || image === void 0 ? void 0 : image.src,
                loop: true,
                autoPlay: true,
                muted: true,
                playsInline: true,
                loading: "lazy",
                preload: "metadata"
            }),
            imageHover && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageHover/* default */.Z, (0,_object_spread/* default */.Z)({
                className: cx((styles_module_default()).hoverImage),
                isHovering: isHovering,
                sizesFromBreakpoints: IMAGE_SIZES[layout],
                layout: "fill",
                objectFit: "cover",
                draggable: false,
                priority: priority
            }, imageHover)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).content,
                children: [
                    name && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        className: cx((styles_module_default()).title, titleStyle, theme),
                        render: name
                    }),
                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
                        href: null,
                        isDiv: true,
                        lineProps: {
                            initialLineState: isHovered ? "underlined" : "none"
                        },
                        className: (styles_module_default()).cta,
                        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                        theme: theme
                    }))
                ]
            })
        ]
    }));
}
GenericCard.defaultProps = {
    layout: CardGenericLayoutType.BIG
};
/* harmony default export */ var UI_GenericCard = (GenericCard);

// EXTERNAL MODULE: ./src/components/UI/PushTitleLink/index.tsx
var PushTitleLink = __webpack_require__(65938);
// EXTERNAL MODULE: ./src/components/Slices/PushGeneric/styles.module.scss
var PushGeneric_styles_module = __webpack_require__(6394);
var PushGeneric_styles_module_default = /*#__PURE__*/__webpack_require__.n(PushGeneric_styles_module);
;// CONCATENATED MODULE: ./src/components/Slices/PushGeneric/index.tsx









var PushGeneric_cx = bind_default().bind((PushGeneric_styles_module_default()));
function PushGeneric(param) {
    var className = param.className, pushTitleLink = param.pushTitleLink, items = param.items, aboveTheFold = param.aboveTheFold;
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var hasRegularItem = (items === null || items === void 0 ? void 0 : items.length) === 3;
    if (!items && !pushTitleLink) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: PushGeneric_cx((PushGeneric_styles_module_default()).PushGeneric, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: gridStyle,
            children: [
                pushTitleLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(PushTitleLink/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pushTitleLink), {
                    className: PushGeneric_cx((PushGeneric_styles_module_default()).pushTitle, {
                        hasRegularItem: hasRegularItem
                    }),
                    withDesktopPaddings: true
                })),
                items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                    var isRegular = hasRegularItem && index === 1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_GenericCard, (0,_object_spread/* default */.Z)({
                        layout: isRegular ? CardGenericLayoutType.REGULAR : CardGenericLayoutType.BIG,
                        className: PushGeneric_cx((PushGeneric_styles_module_default()).item, {
                            isRegular: isRegular
                        }),
                        priority: aboveTheFold
                    }, item), "generic_card_".concat(index));
                })
            ]
        })
    });
}
PushGeneric.defaultProps = {};
/* harmony default export */ var Slices_PushGeneric = (PushGeneric);


/***/ }),

/***/ 65938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37444);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95348);
/* harmony import */ var _types_text_styling__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36575);
/* harmony import */ var _components_Abstracts_RichText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7191);
/* harmony import */ var _components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85499);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60118);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62964);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);











var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()));
function PushTitleLink(param) {
    var className = param.className, title = param.title, link = param.link, label = param.label, withDesktopPaddings = param.withDesktopPaddings, theme = param.theme;
    var titleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_7__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalTextPreset.Title40SangBleu */ .C.Title40SangBleu
    });
    var labelStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_7__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalTextPreset.Cta12Grotesk */ .C.Cta12Grotesk,
        textStyling: _types_text_styling__WEBPACK_IMPORTED_MODULE_4__/* .GlobalTextStyling.UpperCase */ .l.UpperCase
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().PushTitleLink), className, theme && withDesktopPaddings ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()) === null || (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()) === void 0 ? void 0 : (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default())["theme-".concat(theme)] : null, {
            withPaddings: withDesktopPaddings
        }),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Abstracts_RichText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                render: title,
                className: cx(titleStyle, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title))
            }),
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Abstracts_RichText__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                render: label,
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().label), labelStyle)
            }),
            link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, link), {
                textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalTextPreset.Cta12Grotesk */ .C.Cta12Grotesk,
                theme: _types_colors__WEBPACK_IMPORTED_MODULE_2__/* .GlobalThemeColors.Black */ .b.Black,
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cta),
                lineProps: {
                    initialLineState: "underlined"
                }
            }))
        ]
    });
}
PushTitleLink.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (PushTitleLink);


/***/ }),

/***/ 85630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95348);
/* harmony import */ var _components_UI_RichText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55071);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60118);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1816);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()));
function Wysiwyg(param) {
    var className = param.className, content = param.content;
    var textStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_4__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_2__/* .GlobalTextPreset.RichTextEditorial */ .C.RichTextEditorial
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().Wysiwyg), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_RichText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content), textStyle),
            render: content
        })
    });
}
Wysiwyg.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (Wysiwyg);


/***/ }),

/***/ 39041:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductsPins":"styles_ProductsPins__mdTed","ratio":"styles_ratio__c9a6S"};

/***/ }),

/***/ 38250:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Video":"styles_Video__g4hI8"};

/***/ }),

/***/ 72487:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ImageWithLabel":"styles_ImageWithLabel__jKQDs","image":"styles_image__8TMZJ","label":"styles_label__68sUM","ratio":"styles_ratio__X_Jq0"};

/***/ }),

/***/ 6394:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PushGeneric":"styles_PushGeneric__y4G3Q","pushTitle":"styles_pushTitle__67nbq","item":"styles_item____xpz","hasRegularItem":"styles_hasRegularItem__ZSzmi","isRegular":"styles_isRegular__05uOq"};

/***/ }),

/***/ 76156:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GenericCard":"styles_GenericCard__AjStf","hoverImage":"styles_hoverImage__mKiq_","video":"styles_video__k45b1","content":"styles_content__klhdH","cta":"styles_cta__HsCeK","title":"styles_title__kh_KF","black":"styles_black__SzdIE","layout-regular":"styles_layout-regular__gO5zZ"};

/***/ }),

/***/ 93478:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PinMarker":"styles_PinMarker__q7YLa","hideOnSmallScreen":"styles_hideOnSmallScreen__tO7np","hideOnLargeScreen":"styles_hideOnLargeScreen__3_zfB","tagContainer":"styles_tagContainer__JB983","tag":"styles_tag___P2Ob","hidden":"styles_hidden__QJQ9U","HorizontalHalf-2":"styles_HorizontalHalf-2__D61Nr","HorizontalHalf-1":"styles_HorizontalHalf-1__HrBYx","VerticalThird-1":"styles_VerticalThird-1___9wH6","VerticalThird-3":"styles_VerticalThird-3__S5S4Y","VerticalThird-2":"styles_VerticalThird-2__EENlo","Toggle":"styles_Toggle__ADdvo","icon":"styles_icon__t4i28","isActive":"styles_isActive__Jl6NA"};

/***/ }),

/***/ 166:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductPinTag":"styles_ProductPinTag__VhN2v","link":"styles_link__gUbDl","container":"styles_container__JeLwb","image":"styles_image__apouW","content":"styles_content__azB4X","topLine":"styles_topLine__78QU6","designer":"styles_designer__Ml7lF","name":"styles_name__iJKzv","mockButton":"styles_mockButton__Q1kQH"};

/***/ }),

/***/ 62964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PushTitleLink":"styles_PushTitleLink__qF5bq","withPaddings":"styles_withPaddings__PijaO","theme-concrete":"styles_theme-concrete__JXyC1","label":"styles_label__f4Uci","cta":"styles_cta__U0Ccm","title":"styles_title__qzn92"};

/***/ }),

/***/ 1816:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Wysiwyg":"styles_Wysiwyg__uirR1"};

/***/ })

}]);